import { render, staticRenderFns } from "./QbUpload.vue?vue&type=template&id=507b8d06"
import script from "./QbUpload.vue?vue&type=script&lang=js"
export * from "./QbUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports